import { createAction } from "@reduxjs/toolkit";
import { Locale } from "../../utils/i18n";

export const setLocale = createAction<Locale | undefined>("SET_LOCALE");
